import Api from "@/services/api";

const basic = "auth";
export default {
  postRegister(params) {
    return Api.default().post("/" + basic + "/registration", params);
  },
  postValidation(params) {
    return Api.default().post("/" + basic + "/validation", params);
  },
  postSignin(params) {
    return Api.default().post("/" + basic + "/signin", params);
  },
  postLogout() {
    return Api.default().post("/" + basic + "/logout");
  },
  postRequestReset(params) {
    return Api.default().post("/" + basic + "/resetrequest", params);
  },
  postReset(params) {
    return Api.default().post("/" + basic + "/reset", params);
  },
  putPassword(params) {
    return Api.default().put("/" + basic + "/updatepassword", params);
  },
  postRefresh(params) {
    return Api.default().post("/" + basic + "/refreshToken", params);
  },
  postInvitation(params) {
    return Api.default().post("/" + basic + "/invitation", params);
  },
  postResent(params) {
    return Api.default().post("/" + basic + "/resentemail", params);
  },
};
